// extracted by mini-css-extract-plugin
export default {"btn_style":"FaqBtn_btn_style__uvOY8","svg_icon":"FaqBtn_svg_icon__VanPz","open":"FaqBtn_open__o1DIH","delete_btn":"FaqBtn_delete_btn__Y1Lvu"};